import React, { useState } from "react";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Table,
  Tab,
  Tabs,
  Alert,
  Badge,
  Nav,
  Breadcrumb,
  Modal,
} from "react-bootstrap";
import { useForm } from "react-hook-form";

import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../../hooks/useCard";
import axiosInstance from "../../config/axiosConfig";

export default function Candidate() {
  const location = useLocation();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const isMonPanierActive =
    location.pathname ===
    "/espace-etudiant/candidate/mon-panierformations/mon-panier";
  const isAjouterPanierActive =
    location.pathname ===
    "/espace-etudiant/candidate/mon-panierformations/ajouter-panier";
  const navigate = useNavigate();

  const handleTabSelect = (key) => {
    if (key === "panier") {
      navigate("/espace-etudiant/candidate/mon-panierformations/mon-panier");
    }
  };

  const addCandidate = (data) => {
    axiosInstance
      .get("api/items")
      .then((response) => {
        console.log("Candidate added successfully", response.data);
      })
      .catch((error) => {
        console.error("Error adding candidate", error);
      });
  };

  const onSubmit = (data) => {
    console.log("Form Data Submitted:", data);
    addCandidate(data);
  };

  return (
    <>
      <Container className="py-5">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Tabs
            defaultActiveKey="info"
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={handleTabSelect}
          >
            <Tab eventKey="info" title="Info personnel">
              <Infopersonnel register={register} errors={errors} />
            </Tab>
            <Tab eventKey="cursus" title="Cursus">
              <Cursus />
            </Tab>
            <Tab eventKey="panier" title=" Panier de formation">
              <PaniersFormation />
            </Tab>
          </Tabs>
          {/* Bouton Soumettre */}
          {/* Submit Button */}
          <div className="text-center mt-4">
            <Button type="submit">Soumettre</Button>
          </div>
        </Form>
      </Container>
    </>
  );
}

export const Infopersonnel = ({ register, errors }) => {
  const [imagePreview, setImagePreview] = useState(null);

  // Function to handle image preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setImagePreview(imageURL);
    }
  };
  return (
    <div>
      <Card className="shadow-sm">
        <Card.Body>
          {/* Section : Informations de Base */}
          <h5 className="mb-3">Informations de Base</h5>
          {/* Image Upload Field */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formProfileimage">
                <Form.Label>Photo de Profil</Form.Label>
                <Form.Control
                  type="file"
                  {...register("image")}
                  onChange={handleImageChange}
                  accept="image/*"
                />
              </Form.Group>
            </Col>
            {imagePreview && (
              <Col md={6}>
                <img
                  src={imagePreview}
                  alt="Aperçu de la photo de profil"
                  className="img-fluid rounded mt-3"
                  style={{ maxWidth: "200px", height: "auto" }}
                />
              </Col>
            )}
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formLastName">
                <Form.Label>Nom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Entrez votre nom"
                  {...register("nom", { require: "Ce champ est requis" })}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formFirstName">
                <Form.Label>Prénom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Entrez votre prénom"
                  {...register("prenom", { require: "Ce champ est requis" })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formBirthDate">
                <Form.Label>Date de Naissance</Form.Label>
                <Form.Control
                  type="date"
                  {...register("datenaissance", {
                    require: "Ce champ est requis",
                  })}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formBirthPlace">
                <Form.Label>Lieu de Naissance</Form.Label>
                <Form.Control
                  type="text"
                  {...register("lieunaissance")}
                  placeholder="Entrez le lieu"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formPassportNumber">
                <Form.Label>Numéro de Passport</Form.Label>
                <Form.Control
                  type="text"
                  {...register("numeropassport")}
                  placeholder="Entrez le numéro"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formNationality">
                <Form.Label>Nationalité</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Entrez votre nationalité"
                  {...register("nationnalite")}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formIssueDate">
                <Form.Label>Date de Délivrance</Form.Label>
                <Form.Control type="date" {...register("datedelivrance")} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formExpiryDate">
                <Form.Label>Date d'Expiration</Form.Label>
                <Form.Control type="date" {...register("dateexpiration")} />
              </Form.Group>
            </Col>
          </Row>

          {/* Section : Contacts Familiaux */}
          <h5 className="mt-4 mb-3">Contacts Familiaux</h5>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formFatherName">
                <Form.Label>Nom du Père</Form.Label>
                <Form.Control
                  type="text"
                  {...register("nomcompletpere")}
                  placeholder="Entrez le nom du père"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formFatherPhone">
                <Form.Label>Numéro de Téléphone du Père</Form.Label>
                <Form.Control
                  type="text"
                  {...register("telephonepere")}
                  placeholder="Entrez le numéro"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formFatheremail">
                <Form.Label>Email Pere</Form.Label>
                <Form.Control
                  type="email"
                  {...register("emailpere")}
                  placeholder="Entrez l' email "
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formMotherName">
                <Form.Label>Nom de la Mère</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Entrez le nom de la mère"
                  {...register("nomcompletmere")}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formMotherPhone">
                <Form.Label>Numéro de Téléphone de la Mère</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Entrez le numéro"
                  {...register("telephonemere")}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formMotheremail">
                <Form.Label>Email Mère</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Entrez l' email "
                  {...register("emailmere")}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Section : Informations Supplémentaires */}
          <h5 className="mt-4 mb-3">Informations Supplémentaires</h5>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formChildrenCount">
                <Form.Label>Nombre d'Enfants</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Entrez le nombre"
                  {...register("nbenfant")}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export const Cursus = () => {
  const [cursus, setCursus] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newCursus, setNewCursus] = useState({
    typeActivite: "",
    date: "",
    anneeScolaire: "",
    pays: "",
    province: "",
    ville: "",
    niveau: "",
    etablissement: "",
    domaine: "",
    moyenne: "",
    commentaire: "",
    justificatif: null,
  });

  const handleCursusChange = (e) => {
    const { name, value, files } = e.target;
    setNewCursus((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const addCursus = () => {
    setCursus([...cursus, newCursus]);
    setNewCursus({
      typeActivite: "",
      date: "",
      anneeScolaire: "",
      pays: "",
      province: "",
      ville: "",
      niveau: "",
      etablissement: "",
      domaine: "",
      moyenne: "",
      commentaire: "",
      justificatif: null,
    });
    setShowModal(false);
  };

  // Fonction pour supprimer un cursus spécifique
  const deleteCursus = (index) => {
    setCursus(cursus.filter((_, i) => i !== index));
  };

  return (
    <div>
      <Button variant="primary" onClick={() => setShowModal(true)}>
        Ajouter un Cursus
      </Button>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Ajouter un nouveau Cursus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formTypeActivite">
                  <Form.Label>Type d'Activité</Form.Label>
                  <Form.Control
                    type="text"
                    name="typeActivite"
                    value={newCursus.typeActivite}
                    onChange={handleCursusChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formDate">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={newCursus.date}
                    onChange={handleCursusChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formAnneeScolaire">
                  <Form.Label>Année Scolaire</Form.Label>
                  <Form.Control
                    type="text"
                    name="anneeScolaire"
                    value={newCursus.anneeScolaire}
                    onChange={handleCursusChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formPays">
                  <Form.Label>Pays</Form.Label>
                  <Form.Control
                    type="text"
                    name="pays"
                    value={newCursus.pays}
                    onChange={handleCursusChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formProvince">
                  <Form.Label>Province / État / Région</Form.Label>
                  <Form.Control
                    type="text"
                    name="province"
                    value={newCursus.province}
                    onChange={handleCursusChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formVille">
                  <Form.Label>Ville</Form.Label>
                  <Form.Control
                    type="text"
                    name="ville"
                    value={newCursus.ville}
                    onChange={handleCursusChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="formNiveau">
              <Form.Label>Niveau</Form.Label>
              <Form.Control
                type="text"
                name="niveau"
                value={newCursus.niveau}
                onChange={handleCursusChange}
              />
            </Form.Group>
            <Form.Group controlId="formEtablissement">
              <Form.Label>Établissement</Form.Label>
              <Form.Control
                type="text"
                name="etablissement"
                value={newCursus.etablissement}
                onChange={handleCursusChange}
              />
            </Form.Group>
            <Form.Group controlId="formDomaine">
              <Form.Label>Domaine</Form.Label>
              <Form.Control
                type="text"
                name="domaine"
                value={newCursus.domaine}
                onChange={handleCursusChange}
              />
            </Form.Group>
            <Form.Group controlId="formMoyenne">
              <Form.Label>Moyenne</Form.Label>
              <Form.Control
                type="text"
                name="moyenne"
                value={newCursus.moyenne}
                onChange={handleCursusChange}
              />
            </Form.Group>
            <Form.Group controlId="formCommentaire">
              <Form.Label>Commentaire</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="commentaire"
                value={newCursus.commentaire}
                onChange={handleCursusChange}
              />
            </Form.Group>
            <Form.Group controlId="formJustificatif">
              <Form.Label>Justificatif</Form.Label>
              <Form.Control
                type="file"
                name="justificatif"
                onChange={handleCursusChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Annuler
          </Button>
          <Button variant="primary" onClick={addCursus}>
            Ajouter
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Tableau des cursus ajoutés */}
      {cursus.length > 0 && (
        <Table striped bordered hover className="mt-4">
          <thead>
            <tr>
              <th>Type d'Activité</th>
              <th>Date</th>
              <th>Année Scolaire</th>
              <th>Pays</th>
              <th>Province</th>
              <th>Ville</th>
              <th>Niveau</th>
              <th>Établissement</th>
              <th>Domaine</th>
              <th>Moyenne</th>
              <th>Commentaire</th>
              <th>Justificatif</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {cursus.map((entry, index) => (
              <tr key={index}>
                <td>{entry.typeActivite}</td>
                <td>{entry.date}</td>
                <td>{entry.anneeScolaire}</td>
                <td>{entry.pays}</td>
                <td>{entry.province}</td>
                <td>{entry.ville}</td>
                <td>{entry.niveau}</td>
                <td>{entry.etablissement}</td>
                <td>{entry.domaine}</td>
                <td>{entry.moyenne}</td>
                <td>{entry.commentaire}</td>
                <td>{entry.justificatif?.name || "Non fourni"}</td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() => deleteCursus(index)}
                    size="sm"
                  >
                    Supprimer
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export const PaniersFormation = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export function MonPanier() {
  const { cart, handleRemoveFromCart } = useCart();

  return (
    <Container>
      {/* <h1>Mon panier</h1> */}
      {cart.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Formation</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((formation, index) => (
              <tr key={index}>
                <td>{formation}</td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() => handleRemoveFromCart(formation)}
                  >
                    Retirer
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>Votre panier est vide.</p>
      )}
      <NavLink to="/espace-etudiant/candidate/mon-panierformations/ajouter-panier">
        <Button variant="primary">Ajouter au panier</Button>
      </NavLink>
    </Container>
  );
}

export function JajouterAuPanier() {
  const { addToCart, showAlert } = useCart(); // Fonctionnalité du panier (fournie par useCart)
  const [search, setSearch] = useState("");
  const [selectedFormation, setSelectedFormation] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const universities = [
    {
      name: "Université Simon Fraser",
      formations: [
        {
          name: "Informatique",
          details: "Détails sur la formation Informatique.",
        },
        { name: "Ingénierie", details: "Détails sur la formation Ingénierie." },
        {
          name: "Sciences Biologiques",
          details: "Détails sur la formation Sciences Biologiques.",
        },
        {
          name: "Sciences Politiques",
          details: "Détails sur la formation Sciences Politiques.",
        },
        {
          name: "Mathématiques",
          details: "Détails sur la formation Mathématiques.",
        },
      ],
    },
    {
      name: "Université de Moncton",
      formations: [
        {
          name: "Littérature",
          details: "Détails sur la formation Littérature.",
        },
        {
          name: "Philosophie",
          details: "Détails sur la formation Philosophie.",
        },
        {
          name: "Psychologie",
          details: "Détails sur la formation Psychologie.",
        },
        { name: "Économie", details: "Détails sur la formation Économie." },
        {
          name: "Gestion d'entreprise",
          details: "Détails sur la formation Gestion d'entreprise.",
        },
      ],
    },
    {
      name: "Université de Saint-Boniface",
      formations: [
        { name: "Éducation", details: "Détails sur la formation Éducation." },
        { name: "Physique", details: "Détails sur la formation Physique." },
        { name: "Chimie", details: "Détails sur la formation Chimie." },
        {
          name: "Arts Visuels",
          details: "Détails sur la formation Arts Visuels.",
        },
        { name: "Musique", details: "Détails sur la formation Musique." },
      ],
    },
    {
      name: "Université Laval",
      formations: [
        { name: "Médecine", details: "Détails sur la formation Médecine." },
        { name: "Droit", details: "Détails sur la formation Droit." },
        { name: "Marketing", details: "Détails sur la formation Marketing." },
        { name: "Histoire", details: "Détails sur la formation Histoire." },
        { name: "Sociologie", details: "Détails sur la formation Sociologie." },
      ],
    },
    {
      name: "Université d’Ottawa",
      formations: [
        { name: "Biologie", details: "Détails sur la formation Biologie." },
        {
          name: "Génie Civil",
          details: "Détails sur la formation Génie Civil.",
        },
        {
          name: "Gestion Hôtelière",
          details: "Détails sur la formation Gestion Hôtelière.",
        },
        {
          name: "Études Internationales",
          details: "Détails sur la formation Études Internationales.",
        },
        {
          name: "Neurosciences",
          details: "Détails sur la formation Neurosciences.",
        },
      ],
    },
  ];

  const handleShowDetails = (formation) => {
    setSelectedFormation(formation);
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
    setSelectedFormation(null);
  };

  // Filtre les formations par le terme de recherche pour chaque université
  const filteredUniversities = universities
    .map((uni) => ({
      ...uni,
      formations: uni.formations.filter((formation) =>
        formation.name.toLowerCase().includes(search.toLowerCase())
      ),
    }))
    .filter((uni) => uni.formations.length > 0); // Affiche uniquement les universités avec des formations correspondantes

  return (
    <Container>
      {/* <h1 className="my-4">Ajouter au panier</h1> */}
      <Form.Control
        type="text"
        placeholder="Rechercher une formation"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-4"
      />
      {showAlert && (
        <Alert variant="success">Formation ajoutée au panier !</Alert>
      )}

      {filteredUniversities.length > 0 ? (
        filteredUniversities.map((uni, uniIndex) => (
          <div key={uniIndex} className="mb-4">
            <h3>{uni.name}</h3>
            <ul className="list-unstyled">
              {uni.formations.map((formation, formIndex) => (
                <li
                  key={formIndex}
                  className="d-flex justify-content-between align-items-center"
                >
                  <span>{formation.name}</span>
                  <Button
                    variant="link"
                    onClick={() => handleShowDetails(formation)}
                  >
                    {selectedFormation === formation
                      ? "Masquer les détails"
                      : "Voir les détails"}
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <p>Aucune formation trouvée.</p>
      )}

      {/* Modal pour afficher les détails de la formation */}
      <Modal show={showDetails} onHide={handleCloseDetails}>
        <Modal.Header closeButton>
          <Modal.Title>Détails de la formation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedFormation && (
            <>
              <h5>{selectedFormation.name}</h5>
              <p>{selectedFormation.details}</p>
              <Button
                variant="success"
                onClick={() => {
                  addToCart(selectedFormation.name);
                  handleCloseDetails();
                }}
              >
                Ajouter au panier
              </Button>
            </>
          )}
        </Modal.Body>
      </Modal>

      <NavLink to="/espace-etudiant/candidate/mon-panierformations/mon-panier">
        <Button variant="primary">Voir mon panier</Button>
      </NavLink>
    </Container>
  );
}
